import { motion } from 'framer-motion'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { useRouter } from 'next/router'

export const SpaceDetailsNav = ({
	spaceTitle,
}: {
	spaceTitle: string
}) => {
	const router = useRouter()
	const { t } = useTranslation()

	const meunItems =
		router.route === '/desks/[zone]/[slug]'
			? ['photos', 'services', 'location']
			: ['photos', 'services', 'prices', 'location']

	return (
		<motion.div
			className='fixed top-0 right-0 left-auto z-20 hidden w-full bg-white pt-[60px] shadow md:block'
			initial={{ opacity: 0, translateY: -100 }}
			animate={{ opacity: 1, translateY: 0 }}
			exit={{ opacity: 0, translateY: -100 }}
		>
			<div className='container flex flex-row items-center justify-between gap-8'>
				<strong className='mr-auto'>{spaceTitle}</strong>

				<div className='flex flex-row gap-12'>
					{meunItems.map((section) => (
						<Link
							key={section}
							href={{ hash: section }}
							className='py-2 hover:text-primary'
						>
							{t(`space:headerMenu.${section}`)}
						</Link>
					))}
				</div>
			</div>
		</motion.div>
	)
}
